import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "field-spacer" }, null, -1)
const _hoisted_2 = { class: "field form-row" }
const _hoisted_3 = ["onUpdate:modelValue"]
const _hoisted_4 = { class: "field form-row" }
const _hoisted_5 = ["onUpdate:modelValue"]

import Form from "@/domains/app/components/Form.vue";
import { FormParams } from "@/domains/app/forms";
import { useUser } from "@/domains/auth/user";
import { onUnmounted, Ref, ref } from "vue";
import { useRouter } from "vue-router";
import { useSheetForm } from "../forms";
import { Sheet } from "../sheets";


export default /*#__PURE__*/_defineComponent({
  props: {
    id: null
  },
  setup(__props: any) {

const props = __props as { id?: string }



let int_id: number | undefined = props.id
    ? parseInt(props.id) || undefined
    : undefined;

let { formArgs: f1, data } = useSheetForm(int_id);
const router = useRouter();

const formArgs = ref<FormParams>();
formArgs.value = f1;

const user = useUser().user;

let isDupplicating = false;
function dupplicate() {
    if (!data.value) return;

    const { formArgs: f2 } = useSheetForm(data as Ref<Sheet>);

    f2.title = "Création d'une fiche";
    formArgs.value = f2;

    data.value.id = -1;

    isDupplicating = true;
    router.push({
        name: "sheets.create",
    });
}

function onSubmitted() {
    if (int_id !== undefined) router.back();
    else router.push({ name: "index" });
}

const unSubscribeRouteGuard = router.beforeEach((to, _from, next) => {
    if (
        !isDupplicating &&
        typeof to.name === "string" &&
        ["sheets.create", "shees.edit"].includes(to.name)
    ) {
        window.location = to.fullPath as unknown as Location;
        return;
    }
    isDupplicating = false;
    next();
});

onUnmounted(() => {
    isDupplicating = false;
    unSubscribeRouteGuard();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Form, _mergeProps(formArgs.value, { onSubmit: onSubmitted }), {
    paid_trip_spacer: _withCtx(() => [
      _hoisted_1
    ]),
    "injuries-zones": _withCtx((fieldConfig) => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fieldConfig.state.value, (injury, index) => {
        return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("label", null, "Zone d'entrée " + _toDisplayString(index + 1), 1),
            _withDirectives(_createElementVNode("input", {
              type: "number",
              min: "0",
              max: "24",
              "onUpdate:modelValue": ($event: any) => ((injury.zone_in) = $event)
            }, null, 8, _hoisted_3), [
              [_vModelText, injury.zone_in]
            ])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("label", null, "Zone de sortie " + _toDisplayString(index + 1), 1),
            _withDirectives(_createElementVNode("input", {
              type: "number",
              min: "0",
              max: "24",
              "onUpdate:modelValue": ($event: any) => ((injury.zone_out) = $event)
            }, null, 8, _hoisted_5), [
              [_vModelText, injury.zone_out]
            ])
          ])
        ], 64))
      }), 128))
    ]),
    footer: _withCtx(() => [
      (
                    _unref(data)?.id && _unref(data).id > 0 && _unref(user) && _unref(user).id === _unref(data)?.user_id
                )
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "btn btn-secondary",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (dupplicate()))
          }, " Duppliquer la fiche "))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 16))
}
}

})